import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { tap, map, catchError } from 'rxjs/operators';
import { ProjectService } from '@newroom-connect/library/services';

import { CustomDomainService } from '../../services/custom-domain.service';

export const CustomDomainGuard: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<boolean> => {
  const projectService = inject(ProjectService);
  const customDomainService = inject(CustomDomainService);

  const projectSlug = route.paramMap.get('projectSlug');

  if (!projectSlug) {
    return of(true);
  }

  return projectService.getProjectSigninConfig(projectSlug).pipe(
    tap((projectSignInConfig) => {
      customDomainService.redirectToCustomDomain(projectSignInConfig.customDomain ?? null);
    }),
    map(() => true), // Always return true since redirect handles the navigation
    catchError(() => of(true)) // Let other guards/resolvers handle project errors
  );
};
